import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closedSprintsLabel: {
		id: 'issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label',
		defaultMessage: '{count} completed {count, plural, one {sprint} other {sprints}}',
		description: 'Header displayed in closed sprints dialog',
	},
});
